import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import GalleryLightbox from '../components/GalleryLightbox';
import ContactForm from '../components/ContactForm';

export default function WorkshopPage() {
  const services = [
    { title: "LODNING AF KNÆKKEDE KÆDER", desc: "Forstærkning og rep. af halskæder, armbånd og vedhæng." },
    { title: "ÆNDRING AF RINGSTØRRELESER", desc: "Vi udvider eller mindske guld- og sølvringe til perfekt pasform." },
    { title: "ISÆTNING AF NYE STEN & BRILLANTER", desc: "Omsætning og udskiftning af diamanter, ædelsten og zirkoner." },
    { title: "PROFESSIONEL RENS & POLERING", desc: "Rens, ultralydsbehandling og højglanspolering af dine smykker." },
    { title: "OVERFLADEBEHANDLING & FORGYLDNING", desc: "Forgyldning, rhodineringsbehandling af hvidguld og oxidering." },
    { title: "REPARATION AF FAMILIEARVESTYKKER", desc: "Kærlig istandsættelse af ældre unika og arvesmykker." },
  ];

  return (
    <>
      <Helmet>
        <title>Guldsmedeværksted - Brønshøj Ure & Guld</title>
        <meta
          name="description"
          content="Professionelt guldsmedeværksted i Brønshøj. Vi udfører lodning, tilpasning af ringstørrelser, isætning af sten og reparation af smykker."
        />
        <meta property="og:title" content="Guldsmedeværksted - Brønshøj Ure & Guld" />
        <meta
          property="og:description"
          content="Professionelt guldsmedeværksted i Brønshøj. Vi udfører lodning, tilpasning af ringstørrelser, isætning af sten og reparation af smykker."
        />
        <meta
          property="og:image"
          content="https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/img-9109-scaled-jpg-1024x768.webp"
        />
      </Helmet>

      {/* Hero Header */}
      <section className="bg-[#0B132B] text-white pt-36 sm:pt-40 lg:pt-56 pb-16 sm:pb-20 lg:pb-28 border-b border-white/10 text-center">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 space-y-4">
          <span className="text-xs uppercase tracking-[0.3em] text-[#B5A897] font-semibold block">
            EGET VÆRKSTED I BUTIKKEN
          </span>
          <h1 className="font-serif text-3xl sm:text-5xl uppercase tracking-[0.2em] font-normal text-white">
            GULDSMEDEVÆRKSTED I BRØNSHØJ
          </h1>
          <p className="text-xs sm:text-sm text-stone-300 max-w-2xl mx-auto uppercase tracking-widest font-sans leading-relaxed">
            På vores eget værksted udfører vores erfarne guldsmede alle former for smykkereparationer, omforandringer og vedligeholdelse med præcision og omhu.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-[#F9F8F6]">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 space-y-20">
          
          {/* Story & Image Row */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="bg-[#F2EFE9] border border-[#E2DDD3] p-10 sm:p-14 space-y-6">
              <div className="w-[1px] h-8 bg-[#B5A897]"></div>
              <h2 className="font-serif text-2xl sm:text-3xl font-normal uppercase tracking-[0.15em] text-[#1A1A1A]">
                HÅNDVÆRK, TRADITION & PRÆCISION
              </h2>
              <div className="text-xs sm:text-sm text-stone-700 leading-relaxed space-y-4">
                <p>
                  Vores erfarne guldsmede står klar på vores værksted. Vi klarer alt fra lodning af knækkede kæder til ændring af ringstørrelser og isætning af nye sten. Kig forbi og få et uforpligtende tilbud på din reparation.
                </p>
                <p>
                  Dine smykker og ure kræver løbende pleje for at forblive smukke. Vi tilbyder professionel rens og polering af smykker, så de skinner som nye.
                </p>
              </div>
              <div className="pt-2">
                <Link
                  to="/smykker-eget-design"
                  className="text-xs font-medium uppercase tracking-[0.2em] text-[#0B132B] border-b border-[#0B132B] pb-1 hover:text-[#B5A897] hover:border-[#B5A897] transition-all"
                >
                  SE UNIKA SPECIALDESIGN HER
                </Link>
              </div>
            </div>

            <div className="border border-[#E2DDD3]">
              <img
                src="/cdn-cgi/image/width=1000,quality=85,format=auto/_assets/img-9109-scaled-jpg-1024x768.webp"
                alt="Guldsmed i gang med lodning og reparation på værkstedet"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          {/* Værkstedsydelser Grid */}
          <div>
            <div className="text-center max-w-xl mx-auto mb-12 space-y-2">
              <div className="w-[1px] h-8 bg-[#B5A897] mx-auto mb-3"></div>
              <span className="text-[10px] uppercase tracking-[0.25em] text-[#B5A897] font-semibold block">
                SPECIALER & REPARATIONER
              </span>
              <h2 className="font-serif text-2xl sm:text-3xl font-normal uppercase tracking-[0.15em] text-[#1A1A1A]">
                VORES VÆRKSTEDSYDELSER
              </h2>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {services.map((item, idx) => (
                <div key={idx} className="bg-[#F2EFE9] p-8 border border-[#E2DDD3] text-center space-y-3 rounded-none shadow-none">
                  <div className="w-[1px] h-6 bg-[#B5A897] mx-auto mb-3"></div>
                  <h3 className="font-serif text-lg font-normal uppercase tracking-[0.15em] text-[#1A1A1A]">{item.title}</h3>
                  <p className="text-xs text-stone-600 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Gallery from CMS */}
          <GalleryLightbox gallerySlug="guldsmedevaerksted" title="BILLEDER FRA GULDSMEDEVÆRKSTEDET" />

          {/* Contact Banner */}
          <div className="w-full pt-4">
            <ContactForm />
          </div>

        </div>
      </section>
    </>
  );
}
